import { connect } from 'react-redux';

import ScrollManagerForViewer from './scroll_manager_for_viewer.jsx';

import {
  getScrollingToSectionId,
  getScrollingToTileUuid,
  getScrollingToAccordionItemUuid,
  getIsScrollingToTop,
  getScrollingAnimationTimeMs,
  getRenderAsMobile
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  doneScrollingToSection,
  doneScrollingToContentItem,
  doneScrollingToTop
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';


const mapStateToProps = (state) => {
  return {
    renderAsMobile: getRenderAsMobile(state),
    isScrollingToTop: getIsScrollingToTop(state),
    scrollingAnimationTimeMs: getScrollingAnimationTimeMs(state),
    scrollingToSectionId: getScrollingToSectionId(state),
    scrollingToTileUuid: getScrollingToTileUuid(state),
    scrollingToAccordionItemUuid: getScrollingToAccordionItemUuid(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onScrollingToSectionIdDone: () => {
      dispatch(doneScrollingToSection());
    },
    onScrollingToContentItemDone: () => {
      dispatch(doneScrollingToContentItem());
    },
    onScrolledToTop: () => {
      dispatch(doneScrollingToTop());
    }
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScrollManagerForViewer);
